import { EMPTY_OBJECT } from '../../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'
import { getSelectDropdownListDividerOption } from '../../Select'
import {
  EMAIL_THREAD_PROFILE_ACTION_COLLAPSE_ALL_MESSAGES,
  EMAIL_THREAD_PROFILE_ACTION_EXPAND_ALL_MESSAGES,
} from '../Email.constants'
import {
  getEmailProfileActionOptionAddNote,
  getEmailProfileActionOptionArchive,
  getEmailProfileActionOptionDownloadFiles,
  getEmailProfileActionOptionMarkAsStarred,
  getEmailProfileActionOptionMarkAsUnread,
  getEmailProfileActionOptionMarkAsUnstarred,
  getEmailProfileActionOptionPrint,
  getEmailProfileActionOptionRestore,
  getEmailProfileActionsWidgetItems,
} from '../EmailProfile'

import ChevronCollapseIcon from '../../../icons/chevron-collapse.svg'
import ChevronExpandIcon from '../../../icons/chevron-expand.svg'

export function getEmailThreadProfileActions({
  entityData,
  sub,
  t,
  widgetsData,
}) {
  const { permissions = EMPTY_OBJECT, starred } = entityData || EMPTY_OBJECT

  const items = [
    ...(starred
      ? [getEmailProfileActionOptionMarkAsUnstarred({ permissions, t })]
      : [getEmailProfileActionOptionMarkAsStarred({ permissions, t })]),
    getEmailProfileActionOptionAddNote({ permissions, t }),
    getEmailProfileActionOptionMarkAsUnread({ permissions, t }),
    getEmailProfileActionOptionDownloadFiles({
      files: widgetsData?.files.items || entityData?.files,
      t,
    }),
    getEmailProfileActionOptionPrint(t),
    getSelectDropdownListDividerOption(),
    getEmailProfileActionOptionArchive({ permissions, sub, t }),
    getEmailProfileActionOptionRestore({ permissions, sub, t }),
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getEmailThreadProfileActionsWidgetItems({
  entityData,
  isAllExpanded,
  sub,
  t,
  widgetsData,
}) {
  const toggleExpandAllMessageAction = isAllExpanded
    ? {
        beforeIconProps: { Icon: ChevronCollapseIcon },
        permission: true,
        tooltip: t('EmailProfile.ActionsWidgetCollapseAllMessagesTooltipKey'),
        value: EMAIL_THREAD_PROFILE_ACTION_COLLAPSE_ALL_MESSAGES,
      }
    : {
        beforeIconProps: { Icon: ChevronExpandIcon },
        permission: true,
        tooltip: t('EmailProfile.ActionsWidgetExpandAllMessagesTooltipKey'),
        value: EMAIL_THREAD_PROFILE_ACTION_EXPAND_ALL_MESSAGES,
      }

  return getEmailProfileActionsWidgetItems({
    entityData,
    sub,
    t,
    widgetsData,
  }).toSpliced(2, 0, toggleExpandAllMessageAction)
}
